import CancelIcon from "@mui/icons-material/Cancel";
import {
  Box,
  DialogContent,
  Drawer,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
const CustomModalDrawer = ({
  open,
  onClose,
  modalHeader,
  modalFooter,
  footerClasses,
  children,
  classToOveride,
  hasCloseButton,
  subHeader,
  width,
  isModalRequired,
  isDrawerRequired,
  drawerSx,
  modalSx,
  sx,
  headerSx,
  drawerHeaderSx,
  subHeaderVariant,
  isScrollNeeded,
  hasDrawerCloseButton,
}) => {
  return (
    <>
      {isModalRequired && (
        <Modal
          open={open}
          onClose={(_, reason) => {
            if (reason === "backdropClick") return;
            onClose();
          }}
          sx={{ display: { xs: "none", sm: "none", md: "block" }, ...modalSx }}
        >
          <Box
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
              position: "absolute",
              bgcolor: "background.white",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              borderRadius: "1.25rem",
              width: width,
              padding: "2.5rem",
              height: { md: "70%", xxl: "60%" },
              overflowY: "scroll",
              ...classToOveride,
            }}
          >
            {hasCloseButton && (
              <CancelIcon
                sx={{
                  position: "absolute",
                  top: "1.37rem",
                  right: "1rem",
                  cursor: "pointer",
                }}
                onClick={onClose}
              />
            )}
            {modalHeader && (
              <Grid sx={{}} container direction={"column"} mb={2}>
                {modalHeader && (
                  <Grid item>
                    <Typography
                      variant="subHeading"
                      sx={{ fontWeight: "600", ...headerSx }}
                    >
                      {modalHeader}
                    </Typography>
                  </Grid>
                )}
                {subHeader && (
                  <Grid item>
                    <Typography
                      variant="aigBodyL"
                      sx={{ color: "color.aigColor4", fontWeight: "300" }}
                    >
                      {subHeader}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}

            <Box>{children}</Box>

            {modalFooter && (
              <Box
                component={"div"}
                sx={{
                  pt: 1,
                  mt: 1,
                  ...footerClasses,
                }}
              >
                {modalFooter}
              </Box>
            )}
          </Box>
        </Modal>
      )}

      {isDrawerRequired && (
        <Drawer
          sx={{
            display: { xs: "block", sm: "block", md: "none" },
            ...sx,
          }}
          anchor="bottom"
          open={open}
          onClose={onClose}
          PaperProps={{
            sx: {
              borderRadius: "1.25rem 1.25rem 0 0",
              padding: "1.75rem 1.25rem ",
              maxHeight: "80%",

              ...drawerSx,
            },
          }}
        >
          {modalHeader && (
            <Grid
              container
              direction={"column"}
              mb={2}
              sx={{ ...drawerHeaderSx }}
            >
              {hasDrawerCloseButton && (
                <CancelIcon
                  sx={{
                    position: "absolute",
                    top: "1.37rem",
                    right: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={onClose}
                />
              )}
              {modalHeader && (
                <Grid item>
                  <Typography variant="aigHeading3" sx={{ fontWeight: "600" }}>
                    {modalHeader}
                  </Typography>
                </Grid>
              )}
              {subHeader && (
                <Grid item>
                  <Typography variant={subHeaderVariant}>
                    {subHeader}
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
          {isScrollNeeded ? (
            <DialogContent
              sx={{ px: "1rem", py: "0.62rem", overflowY: "scroll" }}
            >
              {children}
            </DialogContent>
          ) : (
            <>{children}</>
          )}

          {modalFooter && (
            <Box
              sx={{
                pt: 1,
                mt: 1,
                ...footerClasses,
              }}
            >
              {modalFooter}
            </Box>
          )}
        </Drawer>
      )}
    </>
  );
};

CustomModalDrawer.propTypes = {
  children: PropTypes.node,
  classToOveride: PropTypes.object,
  drawerHeaderSx: PropTypes.object,
  drawerSx: PropTypes.object,
  footerClasses: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hasCloseButton: PropTypes.bool,
  hasDrawerCloseButton: PropTypes.bool,
  headerSx: PropTypes.object,
  isDrawerRequired: PropTypes.bool,
  isModalRequired: PropTypes.bool,
  isScrollNeeded: PropTypes.bool,
  modalFooter: PropTypes.node,
  modalHeader: PropTypes.node,
  modalSx: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  subHeader: PropTypes.node,
  subHeaderVariant: PropTypes.string,
  sx: PropTypes.object,
  width: PropTypes.string,
};

CustomModalDrawer.defaultProps = {
  open: false,
  width: "50%",
  footerClasses: "",
  hasCloseButton: true,
  isDrawerRequired: true,
  isModalRequired: true,
  subHeaderVariant: "aigBodyL",
  isScrollNeeded: false,
  hasDrawerCloseButton: false,
};

export default CustomModalDrawer;
